import React from 'react';
import Events from './main-page/Events/Events';

// import {BrowserRouter,Route,Switch} from 'react-router-dom';
// import Navbar from './main-page/Navbar/MainNavbar/Navbar';




export default function Eventss() {
  return (
    <div style={{display:"flex"}}>
       <Events/>
       <Events/>
    </div>
  )
}
